import Link from 'next/link';
import type { OpenQuestion } from '@/types/open-questions';

/**
 * Article-end open-question hook (Session C #4). Reader→contributor entry point.
 * Renders nothing when there is no question (byte-neutral). Gated upstream by
 * NEXT_PUBLIC_ARTICLE_END_QUESTION + the resolver's still-open re-validation.
 */
export default function ArticleEndQuestion({ question }: { question: OpenQuestion | null }) {
  if (!question) return null;
  return (
    <aside className="mt-8 rounded-lg border-[0.5px] border-divider bg-surface2 px-4 py-4" data-testid="article-end-question">
      <p className="font-mono text-[10px] font-semibold uppercase tracking-[0.1em] text-parchment-dim">
        Still confirming
      </p>
      <p className="mt-2 text-sm text-parchment">{question.question}</p>
      <Link
        href={`/tags/${question.entitySlug}`}
        className="mt-3 inline-block font-mono text-[11px] font-semibold uppercase tracking-[0.08em] text-scout-gold hover:text-scout-gold/80"
      >
        Know the answer? Add a source →
      </Link>
    </aside>
  );
}
